import { PrimeIcons } from "primereact/api";

import { labelReady } from "_constants";

export const StateSourceDone = () => {
  return (
    <div className="source-done flex-container align-center gap-4">
      <span className={PrimeIcons.CHECK}></span>
      <small className="font-weight-600">{labelReady}</small>
    </div>
  );
};
